import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import g from 'src/constants/global';
import wrapper from 'src/redux';
import { actionGetAbout, actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));
const About = dynamic(() => import('src/containers/About'));

const AboutPage = () => {
	return (
		<>
			<HeadC
				title="Tentang Kami"
				description={
					'KlikDokter adalah platform layanan kesehatan digital terintegrasi, ' +
					'menyediakan solusi kesehatan dan layanan lengkap. ' +
					'Yuk, kenali kami lebih jauh di sini.'
				}
			/>
			<About />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());
	await store.dispatch(actionGetAbout());

	return {
		props: {
			pageHeaderContent: {
				title: 'Tentang KlikDokter',
				hideHeadingTitle: true,
			},
		},
		revalidate: g.REVALIDATE_EXP_ARTICLE,
	};
});

export default AboutPage;
